import axios from 'axios';
import {
  Message, Notification
} from 'element-ui';
import router from '../router/index.js'

import { API_BASE_URL } from "@/config/index.js";

const http = axios.create({
  //通用请求头的地址前缀
  baseURL: API_BASE_URL,
  timeout: 300000, //超时时
});

// 添加请求拦截器
http.interceptors.request.use((config) => {
  // 在发送请求之前做些什么

  // let config1 = config
  // config1.headers = {
  //     'Content-Type': "application/json",
  // }


  // let xinxi = sessionStorage.getItem('admintoken') ? sessionStorage.getItem('admintoken') : ''
  // let token = xinxi ? xinxi : ''


  // let shop_id = sessionStorage.getItem('shopId')
  // if (config1.data) {
  //     config1.data.token = token
  //     config1.data.shop_id = shop_id
  // } else {
  //     config1.data = {
  //         token,
  //         shop_id
  //     }
  // }

  // if (config.url.indexOf('userWithdrawExcelExport') > -1 || config.url.indexOf('shopWithdrawExcelExport') > -1) {
  //     config1.responseType = 'blob'
  //     config1.fileName = '导出文件'

  // }
  // return config1;

  config.headers['Content-Type'] = 'application/json';

  let token = sessionStorage.getItem('admintoken') || '';
  let shop_id = sessionStorage.getItem('shopId');

  // ✅ 确保 data 存在
  if (!config.data) {
    config.data = {};
  }

  config.data.token = token;
  config.data.shop_id = shop_id;

  // 导出文件处理
  if (config.url.indexOf('userWithdrawExcelExport') > -1 ||
    config.url.indexOf('shopWithdrawExcelExport') > -1) {
    config.responseType = 'blob';
    config.fileName = '导出文件';
  }

  return config;

}, function (error) {
  // 对请求错误做些什么
  return Promise.reject(error);
});

// 添加响应拦截器
http.interceptors.response.use((response) => {

  // 对响应数据做点什么
  if (response.request.responseURL.indexOf('userWithdrawExcelExport') > -1 || response.request.responseURL.indexOf('shopWithdrawExcelExport') > -1) {
    if (response.data) {
      let blob = new Blob([response.data], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;"
      }); // 为blob设置文件类型，这里以.xlsx为例
      let url = window.URL.createObjectURL(blob); // 创建一个临时的url指向blob对象
      let a = document.createElement("a");
      a.href = url;
      a.download = response.config.fileName || '导出文件';
      a.click();
    }
    return '成功'
  }

  if (response.data) {

    if (response.data.status == 1) {
      return response.data;
    } else if (response.data.status == -998 || response.data.status == -999) {
      // Notification.error({
      //     title: '登录过期',
      //     message: '请重新登录'
      // });
      router.replace('/')
    } else {
      Message.error({
        title: '错误',
        type: 'warning',
        message: response.data.info || '操作失败'
      });
      // return ''
      return Promise.reject(response.data)
    }


  }
}, function (error) {

  Message.error({
    showClose: true,
    message: '请求失败'
  })
  // 对响应错误做点什么
  return Promise.reject(error);
});

export default http
